module.exports = __webpack_public_path__ + "img/75982.3fb7679d.svg";